import { useIsBrokerUser } from "contexts/authorization/hooks/use-is-broker-user"
import { resolveBrokerMaxBackdateDays } from "utils/pocketknife/cancellation-date"

/**
 * How many days a broker may backdate a cancellation effective date, from the
 * policy's product brokerMaxCancellationBackdateDays setting. Undefined when
 * the current user isn't a broker, as Stella agents and admins aren't
 * restricted.
 */
export const useBrokerBackdateLimit = (
  productSetting: number | undefined
): number | undefined => {
  const isBroker = useIsBrokerUser()

  return isBroker ? resolveBrokerMaxBackdateDays(productSetting) : undefined
}
